<template>
    <div>
        <card-component class="mt-3">
            <template v-slot:content>
                <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                        <label for="startDate" class="form-label">Serviço</label>
                        <v-select class="w-50" name="service" id="service" :options="optServices"
                                  v-model="serviceSelected" @input="errors.service=''">
                        </v-select>
                        <alert-error-message-component class="p-1" v-if="errors.service" :mesage="errors.service">
                        </alert-error-message-component>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-3">
                                <label for="startDate" class="form-label">Data inicial</label>
                                <input type="date" class="form-control" name="startDate" id="startDate" v-model="startDate">
                            </div>
                            <div class="col-12 col-md-6">
                                <label for="endDate" class="form-label" >Data final</label>
                                <input type="date" class="form-control" name="endDate" id="endDate"  v-model="endDate">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 d-flex justify-content-center">
                        <button type="button" class="btn btn-primary" @click.prevent="openReport">Gerar</button>
                    </div>
                </div>
            </template>
        </card-component>
    </div>
</template>

<script>
export default {
    name: "ReporteOrderCustomerDaily",
    props: [ 'report_route', 'route_services'],
    data() {
        return {
            optServices: [],
            serviceSelected: '',
            startDate: '',
            endDate: '',
            service: '',
            errors: {
                'startDate': '',
                'endDate': '',
                'service': ''
            }
        }
    },

    methods:{

        getServices() {
            let urlServices = this.route_services;
            axios.get(urlServices)
                .then(response => {
                    response.data.forEach(s => {
                        this.optServices.push({label: s.name, code: s.id});
                    });
                    this.optServices.push({label: 'TODOS', code: '0'});
                })
                .catch(error => {
                    console.log(error);
                });
        },

        openReport(){
            window.open(this.report_route+'?startDate='+this.startDate+'&endDate='+this.endDate+'&service='+this.serviceSelected.code, '_blank');
        }
    },

    mounted() {
        this.getServices();
    }
}
</script>

<style scoped>

</style>
